export const styles = {
  wrapper: 'grow',
  icon: 'w-2xl h-2xl rounded-md',
  discount: 'w-2xl h-2xl rounded-full bg-accentSecondary10',
};
